package org.zest.insan_360_website.components.widgets

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.framework.annotations.DelicateApi
import com.varabyte.kobweb.silk.components.icons.fa.FaTicketSimple
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import org.jetbrains.compose.web.css.*
import org.zest.insan_360_website.components.layouts.*
import org.zest.insan_360_website.data.page_states.dashboard.MainDashPageState

data class StatsSection(
    val title: String,
    val statistic: String
)

@Composable
fun CreditStatsContainer(
    modifier: Modifier = Modifier,
    mainTitle: String,
    vararg statsSections: StatsSection
) {
    PageContentContainer(
        modifier
            .padding(0.px)
            .justifyContent(JustifyContent.SpaceBetween)
            .backgroundColor(Colors.Transparent)
            .border {
                width(0.px)
            }
    ) {
        Column(Modifier.fillMaxSize().gap(0.5.cssRem).display(DisplayStyle.Flex)) {
            Row(
                Modifier
                    .gap(0.5.cssRem),
                verticalAlignment = Alignment.CenterVertically,
            ) {
                Box(
                    containerShadowStyle.toModifier()
                        .height(2.75.cssRem)
                        .aspectRatio(1f)
                        .backgroundColor(userPageBGColor)
                        .borderRadius(0.75.cssRem)
                        .border {
                            color(userPageBorderStrongColor)
                            width(1.px)
                            style(LineStyle.Solid)
                        },
                    contentAlignment = Alignment.Center
                ) {
                    FaTicketSimple(size = IconSize.LG)
                }
                SpanText(
                    mainTitle,
                    Modifier
                        .fontSize(1.5.cssRem)
                        .fontWeight(FontWeight.Bold)
                        .color(userPagePrimaryTextColor)
                        .flex(1)
                )
            }
            Box(
                containerShadowStyle.toModifier()
                    .fillMaxSize()
                    .flex(6)
                    .borderRadius(0.75.cssRem)
                    .border {
                        color(userPageBorderStrongColor)
                        width(1.px)
                        style(LineStyle.Solid)
                    }
            ) {
                Column(
                    Modifier
                        .fillMaxSize()
                        .padding(1.5.cssRem)
                        .gap(0.5.cssRem)
                ) {
                    statsSections.forEachIndexed { index, section ->
                        Row(
                            Modifier
                                .fillMaxWidth()
                                .justifyContent(JustifyContent.SpaceBetween)
                        ) {
                            SpanText(
                                section.title,
                                Modifier
                                    .fontSize(0.875.cssRem)
                                    .fontWeight(FontWeight.Bolder)
                                    .color(userPageSecondaryTextColor)
                            )
                            if (MainDashPageState.isLoading)
                                Box(Modifier.fillMaxHeight(), contentAlignment = Alignment.Center) {
                                    DotLoading(userPagePrimaryTextColor)
                                }
                            else
                            SpanText(
                                section.statistic,
                                Modifier
                                    .fontSize(0.875.cssRem)
                                    .fontWeight(FontWeight.Bolder)
                                    .color(userPagePrimaryTextColor)
                            )
                        }
                        if (index < statsSections.size - 1) {
                            Box(Modifier.fillMaxWidth().height(1.px).backgroundColor(userPageBorderStrongColor))
                        }
                    }
                }
            }
        }
    }
}

@OptIn(DelicateApi::class)
@Composable
fun StatContainer(title: String, stat: String, icon: @Composable () -> Unit) {
    PageContentContainer(
        containerShadowStyle.toModifier()
            .padding(1.cssRem)
            .fillMaxWidth()
    ) {
        Column(Modifier.gap(1.5.cssRem)) {
            Row(Modifier
                .fillMaxWidth()
                .gap(0.5.cssRem),
                verticalAlignment = Alignment.CenterVertically,
            ) {
                Box(
                    Modifier
                        .height(2.75.cssRem)
                        .aspectRatio(1f)
                        .backgroundColor(userPageBGColor)
                        .borderRadius(0.75.cssRem)
                        .border {
                            color(userPageBorderStrongColor)
                            width(1.px)
                            style(LineStyle.Solid)
                        },
                    contentAlignment = Alignment.Center
                ) {
                    icon()
                }
                SpanText(
                    title,
                    Modifier
                        .fontSize(1.cssRem)
                        .fontWeight(FontWeight.Bold)
                        .color(userPageSecondaryTextColor)
                )
            }
            if (MainDashPageState.isLoading) DotLoading(userPagePrimaryTextColor)
            else
            SpanText(
                text = stat,
                modifier = Modifier
                    .fontWeight(FontWeight.Bolder)
                    .fontSize(2.25.cssRem)
                    .color(userPagePrimaryTextColor)
                    .margin(left = 0.5.cssRem)
            )
        }
    }
}